import { setSaveToCloudStatusHelper } from 'owa-attachment-full-data/lib/utils/setSaveToCloudStatusHelper';
import { orchestrator } from 'satcheljs';
import { setSaveToCloudStatus } from '../actions/internalActions';
import { showSxS } from '../actions/publicActions';

orchestrator(showSxS, () => {
    setSaveToCloudStatusHelper.register(setSaveToCloudStatus);
});
